import { Component } from "react";
import Lottie from "react-lottie";
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Row,
} from "reactstrap";
import contact from "../../assets/img/lotties/Contact.json";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        companyName: "",
        employees: "",
        phone: "",
        email: "",
      },
    };
  }

  handleInput = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", this.state.formData);
    // Add your form submission logic here
  };

  render() {
    return (
      <div className="Contact bg-light pb-3 mt-0">
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg="8" className="text-center">
              <h1
                className="font-family-2 mb-3"
                style={{
                  fontSize: "3rem",
                  fontWeight: "700",
                }}
              >
                Get In Touch
              </h1>
              <p className="lead text-muted" style={{ fontSize: "1.2rem" }}>
                Ready to transform your team communication? Let's discuss how
                Merk Mobile can help your organization.
              </p>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col lg="6" className="mb-5 mb-lg-0">
              <div className="text-center">
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: contact,
                  }}
                  height={400}
                  width={400}
                  style={{ maxWidth: "100%" }}
                />
                <div className="mt-4">
                  <h4 className="text-primary mb-3">Why Contact Us?</h4>
                  <div className="row text-center">
                    <div className="col-4">
                      <div className="mb-3">
                        <i className="fas fa-users fa-2x text-primary"></i>
                      </div>
                      <h6>Team Support</h6>
                    </div>
                    <div className="col-4">
                      <div className="mb-3">
                        <i className="fas fa-cog fa-2x text-primary"></i>
                      </div>
                      <h6>Custom Setup</h6>
                    </div>
                    <div className="col-4">
                      <div className="mb-3">
                        <i className="fas fa-chart-line fa-2x text-primary"></i>
                      </div>
                      <h6>Growth Plan</h6>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="6">
              <Card
                className="border-0 shadow-lg"
                style={{ borderRadius: "16px" }}
              >
                <div className="p-0">
                  <h3
                    className="text-center mb-4 pb-2"
                    style={{
                      color: "white",
                      fontWeight: "600",
                    }}
                  >
                    Contact Form
                  </h3>

                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup className="mb-3 p-0">
                      <Input
                        placeholder="Your Name"
                        name="name"
                        type="text"
                        value={this.state.formData.name}
                        onChange={this.handleInput}
                        required
                        className="py-4 px-3 border-0 rounded"
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e9ecef",
                          fontSize: "16px",
                          borderRadius: "8px",
                        }}
                      />
                    </FormGroup>

                    <FormGroup className="mb-3 p-0">
                      <Input
                        placeholder="Company Name"
                        name="companyName"
                        type="text"
                        value={this.state.formData.companyName}
                        onChange={this.handleInput}
                        required
                        className="py-4 px-3 border-0 rounded"
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e9ecef",
                          fontSize: "16px",
                          borderRadius: "8px",
                        }}
                      />
                    </FormGroup>

                    <Row className="px-2">
                      <Col md="6" className="px-2">
                        <FormGroup className="mb-3">
                          <Input
                            type="number"
                            name="employees"
                            placeholder="Number of Employees"
                            value={this.state.formData.employees}
                            onChange={this.handleInput}
                            className="py-4 px-3 border-0 rounded"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #e9ecef",
                              fontSize: "16px",
                              borderRadius: "8px",
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" className="px-2">
                        <FormGroup className="mb-3">
                          <Input
                            type="tel"
                            name="phone"
                            placeholder="Phone Number"
                            value={this.state.formData.phone}
                            onChange={this.handleInput}
                            required
                            className="py-4 px-3 border-0 rounded"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #e9ecef",
                              fontSize: "16px",
                              borderRadius: "8px",
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup className="mb-3 p-0">
                      <Input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={this.state.formData.email}
                        onChange={this.handleInput}
                        required
                        className="py-4 px-3 border-0 rounded"
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e9ecef",
                          fontSize: "16px",
                          borderRadius: "8px",
                        }}
                      />
                    </FormGroup>

                    <Button
                      type="submit"
                      className="w-100 py-3 rounded"
                      style={{
                        backgroundColor: "#007bff",
                        border: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        borderRadius: "8px",
                        color: "white",
                      }}
                    >
                      Send Message
                    </Button>
                  </Form>

                  <div className="text-center mt-3">
                    <p className="text-white mb-0">
                      We'll get back to you within 24 hours
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Contact;
